import bindAllOfThis from "src/utils/BindThisHelper";
import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { PhaserGamePad } from "src/games/shared/Gamepad";
import { EndGameScene } from "./EndGameScene";

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;
    gamePad: PhaserGamePad;
    vehicle: Phaser.Physics.Matter.Image;

    public static VehicleFrame: string;

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload() {
        this.load.tilemapTiledJSON("map", require("src/assets/qci/maps/construction_maze.json"));
        PhaserGamePad.preload(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.gamePad = new PhaserGamePad(this);
    }

    create() {
        this.initialize();
        this.createScene();
        this.createCollisions();
    }

    createVehicle() {
        var ob = this.map.getObjectLayer("Scene").objects.find((ob: TiledGameObject) => ob.name === "vehicle") as TiledGameObject;
        this.vehicle = this.matter.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", MainScene.VehicleFrame);
        this.vehicle.setFrictionAir(0.1);
        this.vehicle.setBody({
            type: 'rectangle',
            width: this.vehicle.frame.name === "vehicle1little" ? 50 : this.vehicle.frame.name === "vehicle2little" ? 35 : 60,
            height: this.vehicle.frame.name === "vehicle1little" ? 25 : this.vehicle.frame.name === "vehicle2little" ? 10 : 30
        }, {});

        this.vehicle.setMass(2);
        this.matter.world.setBounds(0, 0, this.gameWidth, this.gameHeight);
    }

    createScene() {
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.createFinish();
        this.createVehicle();
    }

    createCollisions() {
        this.map.getObjectLayer("Collision").objects.forEach((ob: TiledGameObject) => {
            var zone = this.matter.add.image(ob.x + ob.width / 2, ob.y + ob.height / 2, "pixel");
            zone.setAlpha(0);
            zone.setDisplaySize(ob.width, ob.height);
            zone.setBody({
                type: 'rectangle',
                width: ob.width,
                height: ob.height,
            }, { isStatic: true });
        });

        var frame = 1;
        this.map.getObjectLayer("Obstacles").objects.forEach((ob: TiledGameObject) => {
            if (frame === 7) {
                frame = 1;
            }
            if (ob.type === "horizontal") {
                var horizontalObstacle = this.matter.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "HorizontalBarricade");
                horizontalObstacle.setBody({
                    type: 'rectangle',
                    width: 80,
                    height: 75,
                }, { isStatic: true });
            }
            else {
                var verticalObstacle = this.matter.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "VerticalBarricade");
                verticalObstacle.setBody({
                    type: 'rectangle',
                    width: 75,
                    height: 80,
                }, { isStatic: true });
            }
        });
    }

    createFinish() {
        var ob = this.map.getObjectLayer("Scene").objects.find((ob: TiledGameObject) => ob.name === "finish") as TiledGameObject;
        var finish = this.matter.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "pixel", null, { label: 'finish' });
        finish.setAlpha(0);
        finish.setBody({
            type: 'rectangle',
            width: ob.width,
            height: ob.height,
        }, { isStatic: true, isSensor: true });
        finish.setSensor(true);
        finish.setStatic(true);
        this.matter.world.on('collisionstart', (event, bodyA, bodyB) => {
            if (bodyB.id === 7) {
                this.endGame();
            }
        });
    }

    update() {
        this.updatePlayerMovement();
    }

    updatePlayerMovement(): void {
        if (this.gamePad.keys.left.isDown) {
            this.vehicle.setAngularVelocity(-0.05);
        }

        else if (this.gamePad.keys.right.isDown) {
            this.vehicle.setAngularVelocity(0.05);
        }

        else if (this.gamePad.keys.left.isUp || this.gamePad.keys.right.isUp) {
            this.vehicle.setAngularVelocity(0);
        }

        if (this.gamePad.keys.up.isDown) {
            this.vehicle.thrust(0.015);
        }
        else if (this.gamePad.keys.up.isUp) {
            this.vehicle.setVelocity(0);
        }

        if (this.gamePad.keys.down.isDown) {
            this.vehicle.thrustBack(0.015);
        }
        else if (this.gamePad.keys.down.isUp) {
            this.vehicle.setVelocity(0);
        }
    }

    endGame() {
        this.vehicle.setStatic(true);
        this.input.removeAllListeners();
        setTimeout(() => {
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 1000);
    }

}



// WEBPACK FOOTER //
// ./src/games/ConstructionMazeGame/scenes/MainScene.ts